import { render } from "./ResponsabilidadeSocial.vue?vue&type=template&id=39a8c1b2&scoped=true"
import script from "./ResponsabilidadeSocial.vue?vue&type=script&lang=js"
export * from "./ResponsabilidadeSocial.vue?vue&type=script&lang=js"

import "./ResponsabilidadeSocial.vue?vue&type=style&index=0&id=39a8c1b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a8c1b2"]])

export default __exports__